<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	import { push } from 'svelte-spa-router';
	//Stores
	import { home_data } from 'src/stores/account/user';
	//Design system components
	import { Container, Alert, Toolbar, Breadcrumbs } from '@Shelly/shelly-design-system';
	//App components
	import ZendureCredentials from '../components/Integrations/Zendure/ZendureCredentials.svelte';
	import ZendureListDevices from '../components/Integrations/Zendure/ZendureListDevices.svelte';
	import ZendureAccountManagement from 'src/components/Integrations/Zendure/ZendureAccountManagement.svelte';
	import { capFirstChar, openExternalLink } from 'src/helpers/utilities';

	let showModal = false;

	const version = 'v. 0.0.4';
</script>

<Toolbar class="mb-m">
	<Breadcrumbs
		aria-label={$format('label_zendure', { default: 'Zendure' })}
		aria-labelledby="zendure-integration-breadcrumbs"
		slot="breadcrumbs"
		links={[
			{ label: 'Integrations', onClick: () => push('/settings/integrations') },
			{ label: 'Zendure' },
		]}
	/>
</Toolbar>

<Alert
	class="mb-m"
	type="warning"
	isHeadingBold
	heading={$format('alert_heading_test_functionality', {
		values: { version },
		default: 'This is test functionality' + version,
	})}
	message={$format('alert_warning_message_zendure_integration_alpha_warning', {
		default: `Zendure integration is in alpha testing phase.`,
	})}
	cta={{
		title: capFirstChar(
			$format('net_metering_feedback_link', {
				default: 'Give feedback',
			}),
		),
	}}
	on:cta_click={() =>
		openExternalLink(
			'https://community.shelly.cloud/topic/1454-zendure-integration-configuration-and-feedback/',
		)}
/>

{#if !$home_data?.zendure?.user}
	<Container class="mb-s" noScroll>
		<ZendureCredentials on:finish={() => (showModal = true)} />
	</Container>
{:else}
	<Container class="mb-s" noScroll>
		<ZendureListDevices />
	</Container>
	<Container class="mb-s" noScroll>
		<ZendureAccountManagement />
	</Container>
{/if}
